import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { LoginQueryParams } from '../types';
import { isAnonymousAccessibleSharedUrl } from '../utils';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoginRedirectGuard implements CanActivate {
  private auth = inject(AuthService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    // This only stops the guard's blanket pre-emptive redirect for pages anonymous callers can open.
    if (isAnonymousAccessibleSharedUrl(state.url)) {
      return of(true);
    }

    return this.auth.isAuthenticated$.pipe(
      map((loggedIn: boolean) => {
        if (loggedIn) {
          return true;
        }
        // Redirect to your custom login page with a strongly-typed returnUrl param
        return this.router.createUrlTree(['/login'], {
          queryParams: { [LoginQueryParams.RETURN_URL]: state.url },
        });
      }),
    );
  }
}
